import UKLoadingIcon from "@/components/UKLoadingIcon";
import { Box, Typography } from '@mui/material';
import { useTranslation } from '@/i18n/client';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

interface LoadingProps {
    text?: string;
    style?: React.CSSProperties;
}

// 使用 styled 组件来创建自定义样式的 Box
const LoadingContainer = styled(Box)({
    width: '107px',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    padding: '20px 0px',
    backgroundColor: 'rgba(0, 0, 0, .7)',
    borderRadius: '12px',
    zIndex: 9999,
});

const UKBlackLoading: FC<LoadingProps> = ({
    text,
    style,
}) => {
    const { t } = useTranslation()

    return (
        <LoadingContainer style={style}>
            <UKLoadingIcon/>
            <Typography variant="body1" component="div" sx={{ 
                color: '#fff', 
                fontSize: '14px', 
                fontWeight: '700', 
                lineHeight: 1, 
                width: '80%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textAlign: 'center'
            }}>
                {text || `${t('common.pageStatus.loading')}...`}
            </Typography>
        </LoadingContainer>
    );
};

export default UKBlackLoading;
